import SvgIcon from './SvgIcon';
import './svg-icon.scss';

export default SvgIcon;
